import { CarrierModel } from '../../../../../../common/models/carrier.model';
import { ControlProperty } from '../../../../../../common/models/forms.model';
import { FileAttachmentType } from '../../../../../../common/models/file-attachment.model';
import { AttachmentSealModel, SourceSealModel } from '../../../../../../common';
import { LocalDateRangeModel } from '../../../../../models/local-date.model';
import { AllocationViewActionAttachmentsModel } from '../allocation-attachments.model';
import {
  AllocationViewActionRequestSlotModel,
  AllocationViewActionRequestUliModel,
} from '../allocation-view-action-request.model';

export class AllocationViewSecurityModel {
  carrier: CarrierModel;
  comments: AllocationViewActionAttachmentsModel;
  firstName: string;
  hubId: number;
  lastName: string;
  propertyOfAnother: boolean;
  remainingDrivingTime: number;
  securityCheckPassed: boolean;
  serviceTime: LocalDateRangeModel;
  slot: AllocationViewActionRequestSlotModel;
  truckId: number;
  truckSeal: SourceSealModel;
  trailerSeal: SourceSealModel;
  ulis: AllocationViewActionRequestUliModel[];
}
export class AllocationViewSecurityWithAttachmentSealModel {
  carrier: CarrierModel;
  comments: AllocationViewActionAttachmentsModel;
  firstName: string;
  hubId: number;
  lastName: string;
  propertyOfAnother: boolean;
  remainingDrivingTime: number;
  securityCheckPassed: boolean;
  serviceTime: LocalDateRangeModel;
  slot: AllocationViewActionRequestSlotModel;
  truckId: number;
  truckSeal: AttachmentSealModel;
  trailerSeal: AttachmentSealModel;
  ulis: AllocationViewActionRequestUliModel[];
}

export class AllocationViewSealForm {
  constructor(
    model: SourceSealModel,
    public data: ControlProperty<string> = [model?.data, []],
    public sealNumber: ControlProperty<string> = [model?.sealNumber, []],
    public filename: ControlProperty<string> = [model?.filename, []],
    public mimeType: ControlProperty<FileAttachmentType> = [model?.mimeType, []],
  ) {}
}

export class AllocationViewAttachmentSealForm {
  constructor(
    model: AttachmentSealModel,
    public attachmentId: ControlProperty<string> = [model?.attachmentId, []],
    public sealNumber: ControlProperty<string> = [model?.sealNumber, []],
    public filename: ControlProperty<string> = [model?.filename, []],
    public mimeType: ControlProperty<FileAttachmentType> = [model?.mimeType, []],
  ) {}
}
